import React from "react";

import "./_index.scss";
import { Link } from 'react-router';
import DocLabel from './docLabel';

export default class extends React.Component {
    render() {
        // will switch to metadata tool later
        const { meta, config } = this.props;

        const arrow = ">";
        let title = meta ? meta.name : "";
        let breadcrumb = null;
        if (config && config.breadcrumb) {
            breadcrumb = config.breadcrumb;
        }

        let product = '';
        if (meta && meta.products) {
            product = meta.products.split(',')[0];
        }
        
        return (
            <section className="devnet-doc-breadcrumb"
                data-aos="cus"
                data-aos-anchor-placement="top-top">
                <nav className="devnet-doc-breadcrumb-container">
                    <div className="container">
                        <div className="row">
                            <ol className="col-md-auto devnet-doc-breadcrumb-links">
                                {breadcrumb ?
                                    breadcrumb.map((nav, i) => i === 0 ? (
                                        <li>
                                            <span className="devnet-doc-breadcrumb-title"><a href={nav.url}>{nav.title}</a></span>
                                        </li>
                                    ) : (
                                        <li>
                                            <span className="devnet-doc-breadcrumb-arrow" />
                                            <a href={nav.url}>{nav.title}</a>
                                        </li>
                                    )
                                ) : (
                                    <>
                                        <li>
                                            <span className="devnet-doc-breadcrumb-title"><a href="/docs/">Documentation</a></span>
                                            <span className="devnet-doc-breadcrumb-arrow" />
                                        </li>
                                        <li>
                                            <span className="devnet-doc-breadcrumb-title"><a href="/docs/search/">All</a></span>
                                            <span className="devnet-doc-breadcrumb-arrow" />
                                        </li>
                                        {product && (
                                            <li>
                                                <span className="devnet-doc-breadcrumb-title"><a href={`/docs/search/?products=${encodeURIComponent(product)}`}>{product}</a></span>
                                                <span className="devnet-doc-breadcrumb-arrow" />
                                            </li>
                                        )}
                                        <li>
                                            <span className="devnet-doc-breadcrumb-title">{title}</span>
                                        </li>
                                    </>
                                )}
                            </ol>
                            <DocLabel config={config} />
                        </div>
                    </div>
                </nav>
            </section>
        )
    }
}
